import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function SaveScrollPosition() {
  const location = useLocation();

  useEffect(() => {
    // Save scroll position before leaving the page
    const saveScroll = () => {
      const key = `scroll_${location.pathname}`;
      sessionStorage.setItem(key, window.scrollY.toString());
    };

    window.addEventListener('beforeunload', saveScroll);
    
    // Also save on navigate away
    return () => {
      const key = `scroll_${location.pathname}`;
      sessionStorage.setItem(key, window.scrollY.toString());
    };
  }, [location]);

  useEffect(() => {
    // Restore scroll position when arriving at a page
    const key = `scroll_${location.pathname}`;
    const savedPosition = sessionStorage.getItem(key);
    
    if (savedPosition) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(savedPosition, 10));
      }, 100);
    }
  }, [location]);

  return null;
}
